/**
 * @generated SignedSource<<4c6ad7d33031207816ddb9d1feaf6a9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_item$data = {
  readonly isMultiSku: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"useShowVimeoVideo_item">;
  readonly " $fragmentType": "useItemMediaItems_item";
};
export type useItemMediaItems_item$key = {
  readonly " $data"?: useItemMediaItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useItemMediaItems_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowVimeoVideo_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "aed42c2f360812658a95790bbac8b481";

export default node;
